import { Injectable } from '@angular/core';
import { FormControl, AbstractControl } from '@angular/forms';
import moment from 'moment';

@Injectable()
export class CustomValidators {
	DateValidator(format = 'MM/dd/YYYY'): any {
		return (control: AbstractControl): { [key: string]: any } => {
			const val = moment(control.value, format, true);
			if (!val.isValid()) {
				return { invalidDate: true };
			}

			return null;
		};
	}
}
